/* ============
 * Mutations for the account module
 * ============
 *
 * The mutations that are available on the
 * account module.
 */

import { SET } from './mutation-types';
export default {

  [SET](state, appState) {
    state.home_active = appState.home_active
    state.home_left = appState.home_left
    state.home_titleColor = appState.home_titleColor
    localStorage.setItem('nerzex.appState', JSON.stringify(appState))
  },

}
